function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { mapMutations, mapState } from 'vuex';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
export var useCaseListMixin = {
  data: function data() {
    return {
      items: [],
      useCase: {}
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    getUseCases: function getUseCases() {
      var _this = this;
      var company = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var companyCode = company || this.companyCode;
      if (!companyCode) {
        return;
      }
      this.setShowLoading(true);
      UseCasesService.getUseCasesByCompanyCode(companyCode, params).then(function (response) {
        console.log('getUseCases', response.data.records);
        _this.items = response.data.records;
      }).finally(function () {
        _this.setShowLoading(false);
      });
    },
    getUseCasesByStatus: function getUseCasesByStatus() {
      var _this2 = this;
      var company = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var statusId = arguments.length > 1 ? arguments[1] : undefined;
      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var companyCode = company || this.companyCode;
      this.setShowLoading(true);
      UseCasesService.getUseCasesByStatusId(companyCode, statusId, queryParams).then(function (response) {
        _this2.items = response.data.records;
      }).finally(function () {
        _this2.setShowLoading(false);
      });
    },
    getOwnerUseCasesByStatus: function getOwnerUseCasesByStatus(statusId) {
      var _this3 = this;
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var useLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (useLoading) this.setShowLoading(true);
      UseCasesService.getOwnerUseCasesByStatus(statusId, queryParams).then(function (response) {
        _this3.items = response.data.records;
      }).finally(function () {
        if (useLoading) _this3.setShowLoading(false);
      });
    },
    onOpenDialogUseCase: function onOpenDialogUseCase(item, modalName) {
      this.useCase = item;
      this.openDialog(modalName);
    }
  }),
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['labelCatalog'])), {}, {
    getUseCaseStatus: function getUseCaseStatus() {
      var _this4 = this;
      return function (statusId) {
        var status = _this4.labelCatalog.status_id[statusId.toString()].toUpperCase();
        var color = '';
        var textColor = 'white';
        switch (statusId) {
          case 1:
            color = 'warning';
            break;
          case 2:
            color = 'red';
            break;
          case 3:
            color = 'success';
            break;
          case 4:
            textColor = 'black';
            break;
          case 5:
            color = 'primary';
            break;
          case 7:
            color = 'error';
            break;
          case 10:
            color = '#B1B3B9';
            break;
          case 13:
            color = 'success';
            break;
          case 14:
            color = 'primary';
            break;
          case 19:
            color = '#6200ea';
            break;
        }
        return {
          status: status,
          color: color,
          textColor: textColor
        };
      };
    }
  })
};